(function(){
  function labelizeAll(){
    document.querySelectorAll('.CookieDeclaration .CookieDeclarationTable').forEach(function(tbl){
      var heads = Array.from(tbl.querySelectorAll('thead th')).map(function(th){
        return th.textContent.trim();
      });
      tbl.querySelectorAll('tbody tr').forEach(function(tr){
        Array.from(tr.children).forEach(function(td, i){
          if(!td.hasAttribute('data-label')) td.setAttribute('data-label', heads[i] || '');
        });
      });
    });
  }
  document.addEventListener('DOMContentLoaded', labelizeAll);

  // If you already have a MutationObserver from my earlier snippet,
  // this will piggyback so it also runs after Cookiebot updates.
  var mo = new MutationObserver(function(m){
    for (var x of m){ if (x.addedNodes && x.addedNodes.length){ labelizeAll(); break; } }
  });
  mo.observe(document.documentElement, { childList:true, subtree:true });
})();

document.querySelectorAll('#CookieDeclarationUserStatusLabelWithdraw')
  .forEach(el => [...el.childNodes].forEach(n => { if (n.nodeType === 3) n.remove(); }));
